(function () {
  // Theme editor preview breaks on document prefetch / unsupported redirects
  if (window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode)) {
    return;
  }

  function prefetch(url, as) {
    if (!url) return;
    as = as || 'document';
    try {
      const absolute = new URL(url, window.location.origin).href;
      const existing = document.head.querySelector(
        'link[rel="prefetch"][href="' + absolute + '"], link[rel="prefetch"][href="' + url + '"]'
      );
      if (existing) return;
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = absolute;
      link.as = as;
      document.head.appendChild(link);
    } catch (e) {}
  }

  document.addEventListener(
    'pointerenter',
    function (event) {
      if (!(event.target instanceof Element)) return;
      const element = event.target.closest('[data-prefetch]');
      if (!element || !element.href || element.dataset.prefetched === 'true') return;
      element.dataset.prefetched = 'true';
      prefetch(element.href);
    },
    true
  );
})();
